<script setup>
import { ref, computed, onMounted } from 'vue';
import TableDataAccessUser from "./components/TableDataAccessUser.vue";
const storedRoles = localStorage.getItem('rol');
const roles = ref(storedRoles ? JSON.parse(storedRoles) : []);
const selectedInstitution = ref(null);
const institutions = ref([]);
onMounted(() => {
  const storedInstitutions = localStorage.getItem("instituciones");
  if (storedInstitutions) {
    institutions.value = JSON.parse(storedInstitutions);
  }
});

const hasPersonalRole = computed(() => {
  return roles.value && roles.value.some(role => role.name === 'PERSONAL');
});

</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row mb-3 user-list">
      <div class="col-12">
        <label for="institution-select" class="form-label">Seleccionar institución:</label>
        <select id="institution-select" v-model="selectedInstitution" class="form-select">
          <option v-for="institution in institutions" :key="institution.id" :value="institution.id">
            {{ institution.nombre }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TableDataAccessUser
          v-if="hasPersonalRole && selectedInstitution"
          :key="selectedInstitution"
          :institutionId="selectedInstitution"
        />
      </div>
    </div>
  </div>
</template>

<style>
.user-list 
  {
    background-color: #ffffff;
    margin-left: 0;
    margin-right: 0;
    padding: 20px;
    border-radius: 12px;
}
</style>